

 $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 150) {
        $(".header").addClass("active");
    }else {
        $(".header").removeClass("active");
    }
}); 

